import { inject } from '@angular/core';
import { ResolveFn, RedirectCommand } from '@angular/router';
import { OAuthAuthenticationService } from '../services/oauth-authentication.service';
import { GlobalStateService } from '../state/global-state.service';
import { Router } from '@angular/router';
import { of, map, catchError } from 'rxjs';
import { buildLoginRedirectUrl } from '../utils/url-utils';

type OAuthResolveResult = { authCode: string; company: string } | RedirectCommand;

export const OAuthTokenResolver: ResolveFn<OAuthResolveResult> = (route, state) => {
    // Section: SERVICES
    //----------------------------------------------------------------------
    const oAuthService = inject(OAuthAuthenticationService);
    const globalState = inject(GlobalStateService);
    const router = inject(Router);

    // Section: PRIVATE METHODS
    //----------------------------------------------------------------------
    const handleLoginFailure = (): OAuthResolveResult => {
        globalState.setExternalLoginFailed(true);

        const companyCodeFromStorage = localStorage.getItem('lastUserLoginBrand');
        const loginUrl = buildLoginRedirectUrl('/', companyCodeFromStorage);
        return new RedirectCommand(router.parseUrl(loginUrl));
    };

    // Section: PUBLIC METHODS
    //----------------------------------------------------------------------
    return oAuthService.getLoginConfiguration().pipe(
        map((loginConfig) => {
            const tokenName = loginConfig.redirectUriTokenName || 'id_token';
            const fragment = window.location.hash?.substring(1); // remove '#'
            let authCode: string | null = null;

            if (fragment) {
                const parts = fragment.split('&');
                for (const part of parts) {
                    if (part.startsWith(`${tokenName}=`)) {
                        authCode = part.substring(`${tokenName}=`.length);
                        break;
                    }
                }
            }

            if (!authCode) {
                // fallback a ?query=params
                const queryParams = new URLSearchParams(window.location.search);
                authCode = queryParams.get(tokenName);
            }

            const company = localStorage.getItem('lastUserLoginBrand');

            if (authCode && company) {
                return { authCode, company };
            } else {
                return handleLoginFailure();
            }
        }),
        catchError(() => {
            return of(handleLoginFailure());
        })
    );
};
